import { useState } from 'react'
import { AutoTextarea } from '../../ui/AutoTextarea'
import type { ProductTexts } from './api'

export type TextLang = 'ru' | 'uz'

const LANGS: [TextLang, string][] = [
  ['ru', 'Русский'],
  ['uz', 'Oʻzbekcha'],
]

const FIELDS: [keyof ProductTexts, string][] = [
  ['desc', 'Краткое описание'],
  ['indications', 'Показания'],
  ['contra', 'Противопоказания'],
  ['dosage', 'Способ применения'],
  ['storage', 'Условия хранения'],
]

/** Сколько полей языка заполнено — видно на переключателе, не открывая его. */
function filled(texts: ProductTexts): number {
  return FIELDS.filter(([key]) => texts[key].trim() !== '').length
}

export interface ProductTextsEditorProps {
  ru: ProductTexts
  uz: ProductTexts
  disabled: boolean
  onChange: (lang: TextLang, key: keyof ProductTexts, value: string) => void
}

/**
 * Тексты витрины по языкам. Язык — переключателем, поля — одной колонкой во
 * всю ширину и растут с текстом: инструкция бывает длиннее экрана, в окошке
 * на четыре строки её не прочитать. Пустое поле на узбекском витрина
 * заменяет русским — это видно в подсказке поля.
 */
export function ProductTextsEditor({ ru, uz, disabled, onChange }: ProductTextsEditorProps) {
  const [lang, setLang] = useState<TextLang>('ru')
  const texts = lang === 'ru' ? ru : uz

  return (
    <section className="ui-card" aria-labelledby="pd-texts">
      <div className="ui-card-head">
        <h3 id="pd-texts">Описание для витрины</h3>
        <div className="ui-seg ui-langs" role="group" aria-label="Язык описания">
          {LANGS.map(([value, name]) => {
            const done = filled(value === 'ru' ? ru : uz)
            return (
              <button
                key={value}
                type="button"
                aria-pressed={lang === value}
                onClick={() => {
                  setLang(value)
                }}
              >
                {name}
                <span
                  className="ui-count"
                  data-full={done === FIELDS.length || undefined}
                  aria-label={`заполнено ${done} из ${FIELDS.length}`}
                >
                  {done}/{FIELDS.length}
                </span>
              </button>
            )
          })}
        </div>
      </div>
      <div className="ui-card-body ui-form">
        {FIELDS.map(([key, label]) => {
          const id = `p-${lang}-${key}`
          return (
            <div className="ui-field" key={id}>
              <label className="ui-label" htmlFor={id}>
                {label}
              </label>
              <AutoTextarea
                id={id}
                lang={lang}
                disabled={disabled}
                placeholder={
                  lang === 'uz' && ru[key] ? 'Пусто — покажем текст на русском' : undefined
                }
                value={texts[key]}
                onChange={(e) => {
                  onChange(lang, key, e.target.value)
                }}
              />
            </div>
          )
        })}
      </div>
    </section>
  )
}
